import { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { pvrTheme, inoxTheme } from "./theme/themes";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom-style/style.css"; // == global styling
import "./custom-style/queries.css"; // == global styling
import "./custom-style/mobilequeries.css"; // == global styling
import { cinemaChain } from "./constants";
import { HelmetProvider, Helmet } from "react-helmet-async";
import ReactGA from "react-ga";
import {
  buildCanonicalUrl,
  getAlternateLanguageLinks,
  getCurrentCanonicalUrl,
} from "./global-functions/seo";
import {
  getBreadcrumbSchema,
  getOrganizationSchema,
  getRouteBreadcrumbItems,
  getRouteSchemaPageName,
  getSpeakableSchema,
  getWebsiteSchema,
} from "./global-functions/schema";
import FinalTicket from "./views/final-ticket/FinalTicket";
import FnBLanding from "./views/food-and-beverage/FnBLanding";
import Checkout from "./views/food-and-beverage/Checkout";
import OffersCardPage from "./views/food-and-beverage/OffersCardPage";
import FBOption from "./views/food-and-beverage/FBOption";
import CinemaList from "./views/cinemas/cinemaList/CinemaList";
import MoviesLocation from "./views/food-and-beverage/MoviesLocation";
import SeatDetails from "./views/food-and-beverage/SeatDetails";
import OrderStatus from "./views/food-and-beverage/OrderStatus";
import TrackOderStatus from "./views/food-and-beverage/TrackOrderStatus";
import OrderReceived from "./views/food-and-beverage/component/OrderReceived";
import FoodOffer from "./views/food-and-beverage/foodoffers/FoodOffer";
import FoodRedeem from "./views/food-and-beverage/foodoffers/FoodRedeem";
import CinemaLocationList from "./views/mobile-views/instafood/CinemaLocationList";
import FoodCart from "./views/food-and-beverage/foodoffers/FoodCart";
import OfferActivated from "./views/food-and-beverage/foodoffers/OfferActivated";
import QrScanner from "./views/food-and-beverage/QrScanner";
import ActivatedVoucher from "./views/food-and-beverage/foodoffers/ActivatedVoucher";
import QrScannerDeeplink from "./views/food-and-beverage/QrScannerDeeplink";
import MjQrScannerDeeplink from "./views/food-and-beverage/MJQrScannerDeeplink";
// import ValueVoucher from "./views/value-voucher/ValueVoucher";
import OffersCardDetailPage from "./views/food-and-beverage/OffersCardDetailPage";
import CinemaInOut from "./views/food-and-beverage/CinemaInOut";
import OffersPromocode from "./views/food-and-beverage/OffersPromocode";
import FinalFood from "./views/final-ticket/FinalFood";
import FoodBookingDetails from "./views/mobile-views/mobile-profile/mobile-profile-pages/FoodBookingDetails";
import FnBDatePicker from "./views/mobile-views/instafood/FnBDatePicker";
import HaptikChat from "./views/HaptikBot/HaptikBot";
// import HaptikBot from "./views/HaptikBot/HaptikBot";
import { getResponsiveClasses } from "./views/food-and-beverage/component/ResponsiveClasses";
//import HaptikBot from "./views/HaptikBot/HaptikBot";
import CinemaLauncher from "./views/food-and-beverage/CinemaLauncher";

const React = require("react");
// ==== mobile views pages start rountes ==========
const Msearch = React.lazy(() =>
  import("./views/mobile-views/mobile-search/MSearch")
);
const Fto = React.lazy(() =>
  import("./views/food-and-beverage/Fto")
);
const MobileMovieDetails = React.lazy(() =>
  import("./views/mobile-views/mobile-movie-details/MobileMovieDeatils")
);
const MobilePersonDetails = React.lazy(() =>
  import("./views/mobile-views/mobile-person-details/MobilePersonDetails")
);
const MobileExperience = React.lazy(() =>
  import("./views/mobile-views/mobile-experience/MobileExperience")
);
const MobileCinemas = React.lazy(() =>
  import("./views/mobile-views/mobile-cinemas/MobileCinemas")
);
const MobileMap = React.lazy(() =>
  import("./views/mobile-views/mobile-map/MobileMap")
);
const InstaFood = React.lazy(() =>
  import("./views/mobile-views/instafood/InstaFood")
);
const MobilePayment = React.lazy(() =>
  import("./views/mobile-views/mobile-payment/MobilePayment")
);
const MobileGiftCard = React.lazy(() =>
  import("./views/mobile-views/mobile-gift-cards/MobileGiftCard")
);
const MobileProfile = React.lazy(() =>
  import("./views/mobile-views/mobile-profile/MobileProfile")
);
const MobileTicketSummary = React.lazy(() =>
  import(
    "./views/mobile-views/mobile-profile/mobile-profile-pages/ProfileBookingDetails"
  )
);
const MobileQRFound = React.lazy(() =>
  import("./views/mobile-views/mobile-qr-found/MobileQrFound")
);

const MobileComingSoon = React.lazy(() =>
  import("./views/mobile-views/mobile-coming-soon/MobileComingSoon")
);

const MobileTrailer = React.lazy(() =>
  import("./views/mobile-trailer/MobileTrailer")
);
// Screenit pages
const Screenit = React.lazy(() =>
  import("./views/static-pages/screenit/Screenit")
);
// Promote & earn
const AppFeaturePromote = React.lazy(() =>
  import("./views/static-pages/promote/promote")
);

const SeeAllMovies = React.lazy(() =>
  import("./views/home/now-showing/SeeAllMovies")
);

const Adscampaigns = React.lazy(() =>
  import("./views/ads-campaigns/Adscampaigns")
)


const OnScreenCamp = React.lazy(() =>
  import("./views/create-campaigns/OnScreenCamp"))

const OffScreenCamp = React.lazy(() => import("./views/create-campaigns/OffScreenCamp"))
const GoogleWalletVerify = React.lazy(() => import("./views/common/googlewallet/GoogleWalletVerify"))




// ==== mobile views pages end rountes ============

//Dm4 page

const DMFOUR = React.lazy(() => import("./views/dm4/DMFOUR"));
const DMFOURSTEP2 = React.lazy(() => import("./views/dm4/DMFOURStep2"));
const DMFOURSTEP3 = React.lazy(() => import("./views/dm4/DMFOURStep3"));

const Home = React.lazy(() => import("./views/home/Home"));
const ShowTime = React.lazy(() => import("./views/show-time/ShowTime"));
const SeatLayout = React.lazy(() => import("./views/seat-layout/SeatLayout"));
const SeatLayoutWchat = React.lazy(() =>
  import("./views/seat-layout/SeatLayoutWchat")
);
const GetFood = React.lazy(() => import("./views/get-food/GetFood"));
const CinemasSession = React.lazy(() =>
  import("./views/cinemas/cinemaList/CinemasSession")
);
const ExperienceDetails = React.lazy(() =>
  import("./views/cinemas/experiences/ExperienceDetails")
);
const Experiences = React.lazy(() =>
  import("./views/cinemas/experiences/Experiences")
);
const PAYMENT = React.lazy(() => import("./views/payment/Payment"));
const OldQrCODE = React.lazy(() => import("./views/oldQrFood/OldQrFood"));
const MovieSession = React.lazy(() =>
  import("./views/movie-sessions/MovieSessions")
);
const Cinemas = React.lazy(() => import("./views/cinemas/Cinemas"));
const Offers = React.lazy(() => import("./views/offers/Offers"));
const Passport = React.lazy(() => import("./views/passport/Home"));
const OffersDetail = React.lazy(() => import("./views/offers/OffersDetail"));

//const Passport = React.lazy(() => import("./views/passport/Pasport"));
const ComingSoon = React.lazy(() => import("./views/coming-soon/ComingSoon"));
const ComingSoonCopy = React.lazy(() => import("./views/coming-soon/ComingSoonMd"));
const Giftcards = React.lazy(() => import("./views/gift-cards/GiftCards"));
const BulkGiftcards = React.lazy(() =>
  import("./views/gift-cards/BulkPurchage")
);
const KotakPPplus = React.lazy(() =>
  import("./views/kotak-pp-plus/KotakPPPlus")
);
const MovieOnDemands = React.lazy(() =>
  import("./views/movie-on-demand/MovieOnDemand")
);

// ==== static page toutings =========
const CoroporateBooking = React.lazy(() =>
  import("./views/bulk-booking/coroporate-booking/CoroporateBooking")
);
const Advertise = React.lazy(() =>
  import("./views/static-pages/advertise/Advertise")
);
const AboutUs = React.lazy(() =>
  import("./views/static-pages/about-us/AboutUs")
);
const VPristine = React.lazy(() =>
  import("./views/static-pages/v-pristine/VPristine")
);
const FeedbackPage = React.lazy(() =>
  import("./views/static-pages/feedback/Feedback")
);
const Birthday = React.lazy(() =>
  import("./views/static-pages/birthday-request/Birthday")
);
const Oscar = React.lazy(() => import("./views/oscar/Oscar"));
const Faq = React.lazy(() => import("./views/static-pages/faq/Faq"));
const News = React.lazy(() => import("./views/static-pages/news/News"));
const BeyondMovie = React.lazy(() =>
  import("./views/static-pages/beyond-movies/BeyondMovie")
);
const PrivacyPolicy = React.lazy(() =>
  import("./views/static-pages/privacy-policy/PrivacyPolicy")
);
const Termsconditions = React.lazy(() =>
  import("./views/static-pages/terms-conditions/TermsConditions")
);
const Termsuse = React.lazy(() =>
  import("./views/static-pages/terms-use/Termsuse")
);
const DonationTnc = React.lazy(() =>
  import("./views/static-pages/terms-use/Donation")
);
const Careers = React.lazy(() =>
  import("./views/static-pages/careers-us/Careers")
);

const InvestorSections = React.lazy(() =>
  import("./views/static-pages/investers-section/Investors")
);

const MovileLibrary = React.lazy(() =>
  import("./views/static-pages/movie-library/MovileLibrary")
);

const CinemaFormat = React.lazy(() =>
  import("./views/static-pages/cinema-format/CinemaFormat")
);

const Profile = React.lazy(() => import("./views/profile/Profile"));

const Ticket = React.lazy(() => import("./views/final-ticket/FinalTicket"));
const PassportTicket = React.lazy(() =>
  import("./views/final-ticket/PassportTicket")
);
const GiftCardTicket = React.lazy(() =>
  import("./views/final-ticket/GiftCardTicket")
);
const FoodTicket = React.lazy(() => import("./views/final-ticket/FoodTicket"));

const EarlyAccess = React.lazy(() =>
  import("./views/early-eccess/EarlyAccess")
);
const FilmFestival = React.lazy(() => import("./views/film-festival/Festival"));
const Audio = React.lazy(() => import("./views/static-pages/audio/Audio"));

const SetAlertMovie = React.lazy(() =>
  import("./views/set-alert-movie/SetAlertMovie")
);


const UnpaidTopaid = React.lazy(() =>
  import("./views/unpaid-to-paid/UnpaidToPaid")
);

const PageNotFound = React.lazy(() =>
  import("./views/page-not-found/PageNotFound")
);
const Sitemap = React.lazy(() =>
  import("./views/sitemap/Sitemap")
);

const RouteStructuredData = () => {
  const location = useLocation();
  const canonicalUrl = buildCanonicalUrl(location.pathname);
  const organizationSchema = getOrganizationSchema();
  const websiteSchema = getWebsiteSchema();
  const speakableSchema = getSpeakableSchema({
    name: getRouteSchemaPageName(location.pathname),
    url: canonicalUrl,
  });
  const breadcrumbSchema = getBreadcrumbSchema(
    getRouteBreadcrumbItems(location.pathname)
  );

  return (
    <Helmet>
      <script id="OrganizationSchema" type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script id="WebsiteSchema" type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script id="SpeakableSchema" type="application/ld+json">
        {JSON.stringify(speakableSchema)}
      </script>
      {breadcrumbSchema && (
        <script id="BreadcrumbSchema" type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
    </Helmet>
  );
};

const RouteAlternateLanguageLinks = () => {
  const location = useLocation();
  const alternateLanguageLinks = getAlternateLanguageLinks(
    buildCanonicalUrl(location.pathname)
  );

  return (
    <Helmet>
      {alternateLanguageLinks.map(({ hrefLang, href }) => (
        <link key={hrefLang} rel="alternate" hrefLang={hrefLang} href={href} />
      ))}
    </Helmet>
  );
};


let sdkPromise;

// One script and one initialized SDK for the app, shared by all placements.
function initAdsterWebSdk() {
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      if (window.AdsterSDK) return resolve();
      const hostname = window.location.hostname;
      const domain = hostname === 'inoxmovies.com' || hostname.endsWith('.inoxmovies.com')
        ? 'inoxmovies.com' : 'pvrcinemas.com';
      const script = document.createElement('script');
      script.src = `https://storage.googleapis.com/public-assets-websdk/${domain}.min.js`;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        reject(new Error('Unable to load Adster Web SDK'));
      };
      document.head.appendChild(script);
    }).then(async () => {
      if (!window.AdsterSDK) throw new Error('AdsterSDK not found on window');
      const instance = new window.AdsterSDK();
      try {
        await instance.init();
        window.adsterSdk = instance;
        window.dispatchEvent(new Event('adster-sdk-ready'));
        return instance;
      } catch (error) {
        instance.destroy?.();
        throw error;
      }
    }).catch((error) => {
      sdkPromise = undefined;
      throw error;
    });
  }
  return sdkPromise;
}


function App() {

  const { getWindowWidth } = getResponsiveClasses();
  const themeVal = cinemaChain === "PVR" ? "pvrTheme" : "inoxTheme";
  localStorage.setItem("theme", themeVal);
  const bodyClasses = document.body.classList;
  const themeClassPattern = /Theme$/;

  bodyClasses.forEach(className => {
    if (themeClassPattern.test(className)) {
      bodyClasses.remove(className);
    }
  });
  document.body.classList.add(themeVal);
  if (typeof localStorage !== "undefined") {
    // Store the theme value in localStorage
    localStorage.setItem("theme", themeVal);
  } else {
    // Handle the case where localStorage is not available
    console.error("localStorage is not available");
  }


  useEffect(() => {
    initAdsterWebSdk().catch((error) => console.warn('Adster Web SDK unavailable:', error));
  }, []);

  const theme = cinemaChain === "PVR" ? pvrTheme : inoxTheme;
  const isMovieSessionRoute = window.location.pathname.includes('/moviesessions/');
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 575px)").matches;
  if (cinemaChain === "PVR") ReactGA.initialize("G-CPXWTKDXV8");
  else ReactGA.initialize("G-FYEYSCFLNJ");

  const loading = (
    <div
      className="pt-3 d-flex justify-content-center align-items-center"
      style={{ height: "100vh", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div>
        <i
          className="pi pi-spin pi-spinner"
          style={{
            fontSize: "5em",
            color: cinemaChain === "PVR" ? "#FFCB05" : "#234B9E",
          }}
        ></i>
      </div>
    </div>
  );




  

  // if (!localStorage.getItem("lat")) {
  //   localStorage.setItem("lat", "0.000");
  //   localStorage.setItem("long", "0.000");
  // }

  // Check if localStorage is available
  if (typeof localStorage !== "undefined") {
    // Check if the 'lat' key is not already set
    if (!localStorage.getItem("lat")) {
      // Set the 'lat' and 'long' keys to default values
      localStorage.setItem("lat", "0.000");
      localStorage.setItem("long", "0.000");
    }
  } else {
    // Handle the case where localStorage is not available
    console.error("localStorage is not available");
  }

  const QrScannerRoute = () => {
    const location = useLocation();

    // If there's no query string, render QrScanner
    if (window.matchMedia("(max-width: 575px)").matches && location.pathname.includes("/qr/")) {
      localStorage.setItem("gatagbookingtype", "Food_QR");
      return <QrScanner />;
    }

    // Otherwise, redirect or show another component
    return <GetFood />;
  };

  const QrScannerRoutedeeplink = () => {
    const location = useLocation();

    // If there's no query string, render QrScanner
    if (window.matchMedia("(max-width: 2575px)").matches) {
      return <QrScannerDeeplink />;
    }

    // If there's no query string, render QrScanner
    if (window.matchMedia("(max-width: 2575px)").matches) {
      return <MjQrScannerDeeplink />;
    }

    // Otherwise, redirect or show another component
    return <QrScanner />;
  };
  const fullUrl = getCurrentCanonicalUrl();
  const defaultMetaDescription =
    cinemaChain === "PVR"
      ? "Book movie tickets online at PVR Cinemas. Check latest movie showtimes, now-showing films, upcoming releases and premium cinema experiences across India."
      : "Book movie tickets online at INOX Movies. Check latest movie showtimes, now-showing films, upcoming releases and premium cinema experiences across India.";

  const isPVR = cinemaChain === "PVR";
  return (
    <React.Fragment>
      <HelmetProvider>
       {!isMovieSessionRoute && (
        <Helmet>
          <title>{cinemaChain === "PVR" ? "PVR Cinemas" : "INOX Movies"}</title>
          <link
            rel="icon"
            href={cinemaChain === "PVR" ? "/pvr.ico" : "/inox.ico"}
          />
          <meta name="description" content={defaultMetaDescription} />
          <meta property="fb:app_id" content="68386086163" />
          <meta property="og:title" content={cinemaChain === "PVR" ? "PVR Cinemas – Book Movie Tickets Online" : "INOX Movies – Book Movie Tickets Online"} />
          <meta property="og:description" content={defaultMetaDescription} />
          <meta property="og:image" content={cinemaChain === "PVR" ? "https://originserver-static1-uat.pvrcinemas.com/pvrcms/pvrinox/pvr_web-logo.png" : "https://originserver-static1-uat.pvrcinemas.com/pvrcms/pvrinox/inox_web-logo.png"} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content={cinemaChain === "PVR" ? "PVR Cinemas" : "INOX Movies"} />
          <meta property="og:url" content={cinemaChain === "PVR" ? "https://www.pvrcinemas.com" : "https://www.inoxmovies.com"} />
          <meta property="og:site_name" content={cinemaChain === "PVR" ? "PVR Cinemas" : "INOX Movies"} />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={cinemaChain === "PVR" ? "PVR Cinemas – Book Movie Tickets Online" : "INOX Movies – Book Movie Tickets Online"} />
          <meta name="twitter:description" content={defaultMetaDescription} />
          <meta name="twitter:image" content={cinemaChain === "PVR" ? "https://originserver-static1-uat.pvrcinemas.com/pvrcms/pvrinox/pvr_web-logo.png" : "https://originserver-static1-uat.pvrcinemas.com/pvrcms/pvrinox/inox_web-logo.png"} />
          <meta name="twitter:site" content={cinemaChain === "PVR" ? "@_pvrcinemas" : "@INOXMovies"} />
          <link rel="canonical" href={fullUrl} />
        </Helmet>
        )}
        <ThemeProvider theme={theme}>
          <Suspense fallback={loading}>
            <Router>
              <RouteAlternateLanguageLinks />
              <RouteStructuredData />
              <Routes>
                <Route path="/" name="Home" element={<Home />} />
                <Route path="/home" name="Home" element={<Home />} />
                <Route path="/advertise-with-us" name="Home" element={<Home />} />
                <Route path="/food" element={<FBOption />} /> // food-options
                <Route path="/scan-qr" element={<QrScanner />} /> // scan-qr
                <Route path="/select-cinema-for-fnb" element={<CinemaLocationList />} /> // select-cinema-for-fnb
                <Route path="/fnbdatepicker" element={<FnBDatePicker />} /> // select-cinema-for-fnb
                <Route path="/check-cinema-options" element={<CinemaInOut />} /> //check-cinema-options
                {/* <Route path="/select-food" element={<FnBLanding />} /> //select-food */}
                <Route path="/select-food" element={<FnBLanding />} />
                <Route path="/select-food/:bookingid/:theaterids/:haptikccity" element={<FnBLanding />} />
                <Route path="/fnb-checkout" element={<Checkout />} /> // fnb-checkout
                <Route path="/offerscard" element={<OffersCardPage />} /> // offers
                <Route path="/bankoffer/:name" element={<OffersCardDetailPage />} /> // offer-details
                <Route path="/promocode" element={<OffersPromocode />} /> // offer-promocode
                <Route path="/fnb-seats-selection" element={<SeatDetails />} /> // fnb-seats-selection
                <Route path="/cinemalauncher/:brand/:city/:cinemaId" element={<CinemaLauncher />} />
                <Route path="/cinemalauncher1/:brand/:city/:cinemaId" element={<CinemaLauncher />} />
                <Route path="/fto/:brand/:city/:cinemaId" element={<Fto />} />

                <Route
                  path="/final-food"
                  name="Final Food"
                  element={<FinalFood />}
                />
                <Route path="/order-received" element={<OrderReceived />} />

                {/* Food Offer */}
                {!getWindowWidth ? (
                  <>
                    <Route path="/food-Vouchers-at-boxoffice" element={<FoodOffer />} /> // food-Vouchers-at-boxoffice
                    <Route path="/redeem-offers/:name" element={<FoodRedeem />} />
                    <Route path="/offeractivated" element={<OfferActivated />} />
                    {/* <Route path="/activatedvoucher" element={<ActivatedVoucher />} /> */}
                    <Route path="/foodcart" element={<FoodCart />} />
                  </>
                ) : (
                  <Route path="*" name="Page not found" element={<PageNotFound />} />
                )
                }
                 <Route path="/order-status" element={<OrderStatus />} />
                 <Route path="/track-order-status/:booking_id" element={<TrackOderStatus />} />
                <Route path="/foodbooking" element={<FoodBookingDetails />} />
                <Route
                  path="/playtrailer/:moviename"
                  name="Home"
                  element={<Home />}
                />
                <Route path="/dm-four" name="DMfour" element={<DMFOUR />} />
                <Route
                  path="/dm-fours2"
                  name="DMfourS2"
                  element={<DMFOURSTEP2 />}
                />
                <Route
                  path="/dm-fours3"
                  name="DMfourS3"
                  element={<DMFOURSTEP3 />}
                />

                <Route
                  path="/show-timings"
                  name="Show Time"
                  element={<ShowTime />}
                />
                <Route
                  path="/passport"
                  name="Passport"
                  element={<Passport />}
                />
                <Route
                  path="/screenit"
                  name="Screenit"
                  element={<Screenit />}
                ></Route>
                <Route path="/promote-earn" name="AppFeaturePromote" element={<AppFeaturePromote />} />
                <Route
                  path="/showdetails/*"
                  name="Screenit"
                  element={<Screenit />}
                ></Route>
                <Route
                  path="/moviedetails/:id/:name/:code"
                  name="AppFeaturePromote"
                  element={<AppFeaturePromote />}
                >
                </Route>
                <Route
                  path="/see-all/:name/"
                  name="SeeAllMovies"
                  element={<SeeAllMovies />}
                >
                </Route>
                <Route
                  path="/ads-campaigns"
                  name="Addcampaigns"
                  element={<Adscampaigns />}
                ></Route>

                <Route
                  path="/on-screen-campaigns"
                  name="onscreenCampaigns"
                  element={<OnScreenCamp />}
                ></Route>

                <Route
                  path="/off-screen-campaigns"
                  name="OffscreenCampaigns"
                  element={<OffScreenCamp />}
                ></Route>            

                <Route path="/PSPT" name="Passport" element={<Passport />} />
                <Route
                  path="/moviesessions/:city/:moviename/:mid"
                  name="Movies Session"
                  element={<MovieSession />}
                />
                <Route
                  path="/moviesessions/:city/:moviename/:mid/:expvalue"
                  name="Movies Session"
                  element={<MovieSession />}
                />
                <Route
                  path="/moviesessions/:moviename/:mid"
                  name="Movies Session"
                  element={<MovieSession />}  
                />

                <Route
                  path="/cinemas/:city?"
                  name="Cinemas"
                  element={isMobile ? <MobileCinemas /> : <Cinemas />}
                />
                <Route
                  path="/mobile-map"
                  name="MobileMap"
                  element={<MobileMap />}
                />

                <Route
                  path="/insta-food"
                  name="InstaFood"
                  element={isMobile ? <CinemaInOut /> : <Home />}
                // element={<InstaFood />}
                />
                <Route
                  path="/getqrcode/:cinemacode"
                  name="QR Food"
                  element={<OldQrCODE />}
                />
                <Route
                  path="/booking/:cinemacode"
                  name="QR Food"
                  element={<OldQrCODE />}
                />
                <Route
                  path="/qrcode/:cityName/:theaterId"
                  name="QR Food"
                  element={<MobileQRFound />}
                />
                <Route
                  path="/experience/:city"
                  name="Experience"
                  element={<Experiences />}
                />
                <Route
                  path="/experience"
                  name="Cinemas"
                  element={<Experiences />}
                />
                <Route
                  path="/experience/:city/:format"
                  name="Cinemas"
                  element={<ExperienceDetails />}
                />
                <Route
                  path="/experiencesessions/:format"
                  name="Cinemas"
                  element={<ExperienceDetails />}
                />
                <Route
                  path="/cinemasessions/:city/:cname/:ccode"
                  name="Cinemas"
                  element={<CinemasSession />}
                />
                <Route
                  path="/cinemasessions/:cname/:ccode"
                  name="Cinemas"
                  element={<CinemasSession />}
                />
                <Route path="/offers" name="Offers" element={<Offers />} />
                <Route
                  path="/offers/offersdetails/:id/:name"
                  name="Offers"
                  element={<OffersDetail />}
                />
                {/* isMobile ? <MobileComingSoon /> : */}
                <Route
                  path="/coming-soon"
                  name="Coming Soon"
                  element={<ComingSoon />}
                />
                <Route
                  path="/coming-soon-movie-calender"
                  name="Coming Soon Movie CCalender"
                  element={<ComingSoonCopy showwebheader={false} />}
                />
                <Route
                  path="/comingsoon/:moviename/:mid"
                  name="Coming Soon"
                  element={<ComingSoon />}
                />
                <Route
                  path="/comingsoon/:mid"
                  name="Coming Soon"
                  element={<ComingSoon />}
                />
                <Route
                  path="/seatlayout/:encrypted_id"
                  name="Seat Layout"
                  element={<SeatLayout />}
                />
                <Route
                  path="/seatlayout/:encrypted_id/:haptikcity"
                  element={<SeatLayout />}
                />
                <Route
                  path="/seatlayout-wchat/:encrypted_id"
                  name="Seat Layout"
                  element={<SeatLayoutWchat />}
                />
                <Route path="/food/:city/:cinemaname/:cinemaId" element={<QrScannerRoute />}></Route>
                <Route
                  path="/payment/:cinemaname"
                  element={<PAYMENT />}
                ></Route>
                <Route path="/food/:city/qr/:cinemaId" element={<QrScannerRoute />}></Route>
                <Route path="/food/:city/:cinemaId" element={<QrScannerRoute />}></Route>
                <Route path="/foods/:city/:cinemaId" element={<QrScannerRoutedeeplink />}></Route>
                <Route path="/mj-foods/:city/:cinemaId/:flag" element={<MjQrScannerDeeplink />}></Route>


                <Route
                  path="/gift-cards"
                  name="Gift Card"
                  element={isMobile ? <MobileGiftCard /> : <Giftcards />}
                ></Route>
                <Route
                  path="/bulk-gift-cards"
                  name="Bulk Gift Card"
                  element={<BulkGiftcards />}
                ></Route>
                <Route
                  path="/kotak-pp-plus"
                  name="Kotak PP+"
                  element={<KotakPPplus />}
                ></Route>
                <Route
                  path="/movie-on-demand"
                  name="Movies On Demand"
                  element={<MovieOnDemands />}
                ></Route>
                {/* static pages  */}
                <Route
                  path="/bulkbooking/coroporate-booking"
                  name="Coroporate Booking"
                  element={<CoroporateBooking />}
                ></Route>
                <Route
                  path="/advertise"
                  name="Advertise"
                  element={<Advertise />}
                ></Route>
                <Route
                  path="/about-us"
                  name="About Us"
                  element={<AboutUs />}
                ></Route>
                <Route
                  path="/v-pristine"
                  name="V Pristine"
                  element={<VPristine />}
                ></Route>
                <Route
                  path="/feedback"
                  name="Feedback"
                  element={<FeedbackPage />}
                ></Route>
                <Route
                  path="/birthday-request"
                  name="birthday-request"
                  element={<Birthday />}
                ></Route>
                <Route path="/faq" name="faq" element={<Faq />}></Route>
                <Route
                  path="/campaign/:oscar"
                  name="Oscar"
                  element={<Oscar />}
                ></Route>
                <Route path="/news" name="news" element={<News />}></Route>
                <Route
                  path="/giftticket"
                  name="giftticket"
                  element={<GiftCardTicket />}
                ></Route>
                <Route
                  path="/beyond-movies"
                  name="beyond-movies"
                  element={<BeyondMovie />}
                ></Route>
                <Route
                  path="/privacy-policy"
                  name="privacy-policy"
                  element={<PrivacyPolicy />}
                ></Route>
                <Route
                  path="/terms-conditions/:tabName?"
                  name="terms-conditions"
                  element={<Termsconditions />}
                ></Route>
                <Route
                  path="/terms-use"
                  name="terms-use"
                  element={<Termsuse />}
                ></Route>
                <Route
                  path="/donation-tnc"
                  name="terms-use"
                  element={<DonationTnc />}
                ></Route>
                <Route
                  path="/careers-us"
                  name="careers-us"
                  element={<Careers />}
                ></Route>
                <Route
                  path="/investors-section/:type?"
                  name="Investors"
                  element={<InvestorSections />}
                ></Route>
                <Route
                  path="/movie-library"
                  name="MoveLibrary"
                  element={<MovileLibrary />}
                ></Route>
                <Route
                  path="/cinema-format"
                  name="CinemaFormat"
                  element={<CinemaFormat />}
                ></Route>
                <Route path="/profile/:tab?" name="Profile" element={<Profile />} />
                <Route
                  path="/personaldetails"
                  name="Profile"
                  element={<Profile />}
                />

                <Route
                  path="/mybooking"
                  name="Profile"
                  element={<Profile viewmode="1" />}
                />

                <Route
                  path="/activegiftcard"
                  name="Profile"
                  element={<Profile viewmode="1" gc="1" />}
                />
                <Route
                  path="/myticketgc"
                  name="Profile"
                  element={<Profile viewmode="1" gc="1" />}
                />
                <Route
                  path="/moviealertlist"
                  name="Profile"
                  element={<Profile viewmode="2" />}
                />

                <Route
                  path="/booking-ticket"
                  name="Movie Ticket"
                  element={<Ticket />}
                />
                <Route
                  path="/mjbot"
                  element={<Home />} />
                <Route
                  path="/passport-ticket"
                  name="Passport Ticket"
                  element={<PassportTicket />}
                />

                <Route
                  path="/giftcard-ticket"
                  name="Gift Card Ticket"
                  element={<GiftCardTicket />}
                />
                <Route
                  path="/food-ticket"
                  name="Food Ticket"
                  element={<FoodTicket />}
                />
                <Route
                  path="/m.trailer"
                  name="Trailer&Music"
                  element={<MobileTrailer />}
                />
                <Route
                  path="/early-access/:movieId"
                  name="Early Access"
                  element={<EarlyAccess />}
                />
                <Route
                  path="/live-movies"
                  name="Film Festival"
                  element={<FilmFestival />}
                />
                <Route
                  path="/audio/:var1?/:var2?/:var3?/:var4?/:var5?/:var6?/:var7?/:var8?/:var9?/:var10?/:var11?/"
                  name="AUDIO"
                  element={<Audio />}
                />
                <Route
                  path="/setalert/:movieCode"
                  name="Set Alert"
                  element={<SetAlertMovie />}
                />
                {/* mobile site router start  */}
                <Route path="/m.search" name="Search" element={<Msearch />} />
                <Route
                  path="/m.movie-details/:movieId/:movieType"
                  name="Movie Details"
                  element={<MobileMovieDetails />}
                />
                <Route
                  path="/m.movie-details/person-details/:pId/:pType"
                  name="Movie Details"
                  element={<MobilePersonDetails />}
                />
                <Route
                  path="/m.experience/:city/:exp"
                  name="Experience"
                  element={<MobileExperience />}
                />
                <Route
                  path="/m.payment/:cinemaname"
                  name="Payment"
                  element={<MobilePayment />}
                />
                <Route
                  path="/m.profile"
                  name="Profile"
                  element={<MobileProfile />}
                />
                <Route
                  path="/m.profile/:vouhistory"
                  element={<MobileProfile />}
                />
                <Route
                  path="/m.booking-detail/:bookType/:bookingId/:theaterId"
                  name="Booking Details"
                  element={<MobileTicketSummary />}
                />
                {/* mobile site router end MobileTicketSummary
                 */}
                <Route
                  path="/unpaid-to-paid/:param1/:param2?"
                  name="Unpaid to Paid"
                  element={<UnpaidTopaid />}
                />
                <Route
                  path="*"
                  name="Page not found"
                  element={<PageNotFound />}
                />
                <Route
                  path="/sitemap.xml"
                  element={<Sitemap />}
                />

              </Routes>
            </Router>
          </Suspense>
        </ThemeProvider>
        {/* <HaptikChat /> */}
      </HelmetProvider>

    </React.Fragment>
  );
}

export default App;
